import { render, staticRenderFns } from "./CreatePriceList.vue?vue&type=template&id=6dbbcc8e&scoped=true&"
import script from "./CreatePriceList.vue?vue&type=script&lang=js&"
export * from "./CreatePriceList.vue?vue&type=script&lang=js&"
import style0 from "./CreatePriceList.vue?vue&type=style&index=0&id=6dbbcc8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbcc8e",
  null
  
)

export default component.exports